<template>
  <footer
    class="bg-[var(--alohin-dark)] text-slate-400 p-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 pb-[110px] md:pb-8"
  >
    <div class="flex items-center gap-4">
      <div class="w-8 h-1 bg-[var(--alohin-gradient)] rounded-full"></div>
      <p class="text-sm font-medium">
        &copy; {{ new Date().getFullYear() }} Alohin. Todos os direitos reservados.
      </p>
    </div>
    <div class="flex items-center gap-6">
      <span class="text-xs font-mono bg-slate-800 px-3 py-1 rounded-full text-slate-500">v{{ version }}</span>
    </div>
  </footer>
</template>
<script setup>
import { version } from '@/../package.json';
</script>